import { Card, ThemeProvider } from "@mui/material";
import { keepPreviousData } from "@tanstack/react-query";
import LoadingScreen from "components/loading/LoadingScreen";
import Table from "components/table/Table";
import { ALL_OPTION } from "constant";
import { useFormik } from "formik";
import { convertBusinessCodeToBusinessName } from "helper/business-management-helper";
import { usePagination } from "hooks/usePagination";
import { useMemo } from "react";
import { useState } from "react";
import {
  useGetListBusiness,
  useGetListBusinessUser,
} from "service/query/business-management.query";
import muiTheme from "theme/muiTheme";

import BusinessUserFilter from "./components/BusinessUserFilter";

const BusinessUser = () => {
  const [filter, setFilter] = useState(null);

  const {
    page,
    pageSize,
    limit,
    skip,
    handleChangePage,
    handleChangePageSize,
  } = usePagination();

  const { data: listBusiness } = useGetListBusiness();

  const columns = useMemo(
    () => [
      { id: "fullname", name: "Tên người dùng" },
      { id: "email", name: "Email" },
      {
        id: "business",
        name: "Tên nghiệp vụ",
        render: (record) =>
          convertBusinessCodeToBusinessName(listBusiness, record.businessCode),
      },
      {
        id: "subOrg",
        name: "Bưu cục",
        render: (record) => record.province?.name,
      },
      {
        id: "phoneNumber",
        name: "Số điện thoại",
      },
    ],
    [listBusiness]
  );

  const handleSubmit = ({ businessCode, cityCode, name, phoneNumber }) => {
    setFilter({
      type: businessCode === ALL_OPTION.value ? null : businessCode,
      cityCode: cityCode.includes(ALL_OPTION.value)
        ? null
        : cityCode?.join(",") || null,
      nameKeyword: name.trim() || null,
      numberPhoneKeyword: phoneNumber.trim() || null,
    });
    handleChangePage(1);
  };

  const formik = useFormik({
    initialValues: {
      businessCode: ALL_OPTION.value,
      cityCode: [ALL_OPTION.value],
      name: "",
      phoneNumber: "",
    },
    onSubmit: handleSubmit,
  });

  const { data: listBusinessUser, isFetching } = useGetListBusinessUser(
    {
      skip,
      limit,
      ...filter,
    },
    { placeholderData: keepPreviousData }
  );

  return (
    <ThemeProvider theme={muiTheme}>
      <Card sx={{ p: 2, mb: 2 }}>
        <BusinessUserFilter formik={formik} />
      </Card>
      <Card>
        <Table
          columns={columns}
          data={listBusinessUser?.data}
          toolbar={{
            title: "Danh sách người dùng",
          }}
          pagination={{
            page,
            pageSize,
            totalItems: listBusinessUser?.total,
            onPageChange: handleChangePage,
            onPageSizeChange: handleChangePageSize,
          }}
        />
      </Card>

      <LoadingScreen loading={isFetching} />
    </ThemeProvider>
  );
};

export default BusinessUser;
